"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optionProps = exports.labelProps = exports.OPTION_HEIGHT = exports.FILTERS_CONTAINER_CLEAR_BUTTON = exports.FILTERS_CONTAINER = exports.COLOR_ICON_SIZE = void 0;
const FILTERS_CONTAINER = exports.FILTERS_CONTAINER = 'filters-container';
const FILTERS_CONTAINER_CLEAR_BUTTON = exports.FILTERS_CONTAINER_CLEAR_BUTTON = 'filters-container-clear-button';
const COLOR_ICON_SIZE = exports.COLOR_ICON_SIZE = 16;
const OPTION_HEIGHT = exports.OPTION_HEIGHT = 45;
const optionProps = exports.optionProps = {
    height: OPTION_HEIGHT,
    iconSize: COLOR_ICON_SIZE
};
const labelProps = exports.labelProps = {
    fontWeight: 'bold'
};
